import { Component, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogClose,
} from '@angular/material/dialog';
import {
  RunTransition,
  WorkflowService,
} from 'src/app/shared/services/workflow/workflow.service';
import { RunTransitionWithDialog } from '../../services/workflow/workflow.service';
import { PayeePopupComponent } from '../../payee-popup/payee-popup.component';
import { PayeeIconComponent } from '../../payee-icon/payee-icon.component';
import { PayeeButtonComponent } from '../../payee-buttons/payee-button/payee-button.component';

@Component({
  selector: 'app-start-execution-dialog',
  templateUrl: './start-execution-dialog.component.html',
  styleUrls: ['./start-execution-dialog.component.scss'],
  imports: [
    PayeePopupComponent,
    PayeeIconComponent,
    PayeeButtonComponent,
    MatDialogClose,
  ],
})
export class StartExecutionDialogComponent {
  private dialogRef =
    inject<MatDialogRef<StartExecutionDialogComponent>>(MatDialogRef);
  data = inject<RunTransitionWithDialog>(MAT_DIALOG_DATA);
  private workflowService = inject(WorkflowService);

  loading = false;

  async submit(): Promise<void> {
    const closeValue: RunTransition = {
      ...(this.data.extraParams ?? {}),
      caseId: this.data.caseId,
      transitionId: this.data.transitionId,
    };

    this.loading = true;
    try {
      await this.workflowService.runTransition(closeValue);
      this.dialogRef.close(closeValue);
    } catch (error) {
      this.workflowService.showTransitionError(error);
    } finally {
      this.loading = false;
    }
  }
}
